import { createAsyncActionTypes } from '../utils';

export const TEST_SERVICES = createAsyncActionTypes('TEST_SERVICES');
